<template>
  <div class="customer-edit-quotations container-fluid">
    <customer-show-quotation ref="showquotation" :customer="customer" :clinic="clinic" @submit="updateQuotations">
    </customer-show-quotation>
    <customer-show-treatment ref="showtreatment" :customer="customer" :clinic="clinic" @submit="updateQuotations">
    </customer-show-treatment>

    <div class="row customer-edit-quotations__topbar">
      <div class="col-md-9 d-flex align-items-center justify-content-start">
        <v-select style="flex: 1 1 320px" ref="psearch" class="wabident-selector filter" @search="searchProducts"
          :filterable="false" :options="products" placeholder="Filtrar por tratamiento/producto ..."
          v-model="selected_product"></v-select>

        <div v-if="is_dental" class="mx-3" style="margin-top:18px">
          <single-tooth-selector v-model="tooth" style="padding: 6.5px 12px"></single-tooth-selector>
          <label for="customer_timeline_tooth" class="wabident-info">Pieza</label>
        </div>

        <v-select style="flex: 1 1 150px" ref="statusfilter" class="wabident-selector filter mx-2" :filterable="false"
          :options="status_filters" placeholder="Filtrar por estado" v-model="status"></v-select>
      </div>
      <div class="col-md-3">
        <button type="button" @click="addNewQuotation" class="btn btn-wabident-round float-right mt-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <g clip-path="url(#clip0_203_1328)">
              <path
                d="M10.4508 5.05079L6.94923 5.05079L6.94923 1.54923C6.94923 1.29748 6.84922 1.05604 6.67121 0.878026C6.49319 0.700013 6.25176 0.600007 6.00001 0.600007C5.74826 0.600007 5.50682 0.700013 5.32881 0.878026C5.15079 1.05604 5.05079 1.29748 5.05079 1.54923L5.05079 5.05079L1.54922 5.05079C1.29748 5.05079 1.05604 5.15079 0.878025 5.32881C0.700012 5.50682 0.600006 5.74826 0.600006 6.00001C0.600006 6.25175 0.700012 6.49319 0.878025 6.6712C1.05604 6.84922 1.29748 6.94922 1.54922 6.94922L5.05079 6.94922L5.05079 10.4508C5.05079 10.7025 5.15079 10.944 5.32881 11.122C5.50682 11.3 5.74826 11.4 6.00001 11.4C6.25175 11.4 6.49319 11.3 6.6712 11.122C6.84922 10.944 6.94922 10.7025 6.94922 10.4508L6.94922 6.94923L10.4508 6.94923C10.7025 6.94923 10.944 6.84922 11.122 6.67121C11.3 6.49319 11.4 6.25176 11.4 6.00001C11.4 5.74826 11.3 5.50682 11.122 5.32881C10.944 5.15079 10.7025 5.05079 10.4508 5.05079Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_203_1328">
                <rect width="12" height="12" fill="white" />
              </clipPath>
            </defs>
          </svg>
          Añadir Nuevo Plan
        </button>
      </div>
    </div>
    <div class="customer-edit-quotations__list">
      <draggable v-model="quotations" handle=".customer-edit-quotation__handle" @change="reorderQuotations">
        <transition-group>
          <customer-edit-quotation v-for="quotation in quotations" :customer="customer" :key="quotation.id"
            @submit="onSubmit" @edit="editQuotation" @payments="genQuotationPayments" @addTreatment="addTreatment"
            @editTreatment="editTreatment" @deleteTreatments="deleteTreatments" @approveTreatments="approveTreatments"
            @approve="approveQuotation" :quotation="quotation" :doctor_names="doctor_names"
            @reorderTreatments="reorderTreatments" :product="selected_product_id" :tooth="tooth">
          </customer-edit-quotation>
        </transition-group>
      </draggable>
      <customer-edit-quotation v-if="this.unquoted_treatments.length" :customer="customer" :key="0" @submit="onSubmit"
        @editTreatment="editTreatment" @deleteTreatments="deleteTreatments" :quotation="unquoted_quotation"
        :doctor_names="doctor_names" :unquoted="true" @addTreatment="addTreatment"
        @reorderTreatments="reorderTreatments" :product="selected_product_id"></customer-edit-quotation>
    </div>
  </div>
</template>

<script>
export default {
  props: ["customer"],
  data() {
    return {
      searched_products: [],
      quotation_products: [],
      selected_product: null,
      status: null,
      tooth: 0,
      status_filters: [
        {
          label: "Sin aprobar",
          value: "unapproved",
        },
        {
          label: "Aprobados",
          value: "approved",
        },
        {
          label: "Apr. Parcial",
          value: "partial",
        },
      ],
      quotations: [],
      unquoted_treatments: [],
    };
  },
  computed: {
    is_dental() {
      return this.clinic && this.clinic.type == 'dental';
    },
    doctor_names() {
      let ret = {};
      if (this.clinic && this.clinic.doctors) {
        this.clinic.doctors.forEach((d) => {
          if (d.doctor) {
            ret[d.doctor.id] = d.name;
          }
        });
      }
      return ret;
    },
    products() {
      return this.searched_products.map((p) => {
        return {
          label: p.name,
          value: p,
        };
      });
    },
    selected_product_id() {
      if (!this.selected_product) return null;
      return this.selected_product.value.id;
    },
    unquoted_quotation() {
      return {
        id: 0,
        notes: "TRATAMIENTOS SIN PLANIFICAR",
        treatments: this.unquoted_treatments,
      };
    },
    ...mapGetters(["clinic", "is_core", "msgwindow", "errorwindow"]),
  },
  watch: {
    status() {
      this.updateQuotations();
    },
    selected_product() {
      this.updateQuotations();
    },
  },
  methods: {
    addNewQuotation() {
      this.$refs.showquotation.showNew([], this.unquoted_treatments);
    },
    editQuotation(quotation) {
      this.$refs.showquotation.showEdit(quotation, this.unquoted_treatments);
    },
    genQuotationPayments(quotation) {
      this.$refs.genpayments.show(quotation, this.unquoted_treatments);
    },
    approveQuotation(approved, quotation) {
      const verb = approved ? "approve" : "unlock";
      axios
        .post(
          `/customer/${this.customer.id}/quotation/${quotation.id}/${verb}`,
          {}
        )
        .then((response) => {
          this.msgwindow.success("Plan actualizado con exito");
          quotation.is_approved = approved;
        })
        .catch((err) => {
          console.log("[ERR] doApproveQuotation ", err);
          this.msgwindow.error("Error actualizando !");
        })
        .then(() => {
          this.updateQuotations();
        });
    },
    onSubmit() {
      this.updateQuotations();
    },
    approveTreatments(treatment_ids, status) {
      axios
        .post(`/customer/${this.customer.id}/approve_treatments`, {
          treatments: treatment_ids,
          approved: status,
        })
        .then((response) => {
          this.msgwindow.success("Tratamientos actualizados");
        })
        .catch((err) => {
          console.log("[ERR] deleteTreatments ", err);
          this.msgwindow.error("Error actualizando tratamientos !");
        })
        .then(() => {
          this.updateQuotations();
        });
    },
    updateQuotations() {
      let params = {
        product_id: this.selected_product_id,
        status: this.status ? this.status.value : null,
      };

      axios
        .get(`/customer/${this.customer.id}/quotation`, {
          params,
        })
        .then((response) => {
          this.quotations = response.data.quotations;
          this.unquoted_treatments = response.data.unquoted_treatments;
          this.updateQuotationProductIds();
          this.$emit("updateQuotations", this.quotations);
        })
        .catch((error) => {
          this.msgwindow.error("Error cargando planes");
        });
    },
    updateQuotationProductIds() {
      let dict = {};


      this.quotations.forEach((quotation) => {
        quotation.quotationlines.forEach((line) => {
          dict[line.product_id] = true;
        });
      })

      this.quotation_products = Object.keys(dict).filter((e) => Boolean(e));
    },
    addTreatment(quotation) {
      this.$refs.showtreatment.showNew([], quotation.id);
    },
    editTreatment(treatment) {
      this.$refs.showtreatment.showEdit(treatment);
    },
    deleteTreatments(treatment_ids) {
      axios
        .post(`/customer/${this.customer.id}/delete_treatments`, {
          treatments: treatment_ids,
        })
        .then((response) => {
          this.msgwindow.success("Tratamientos borrados");
        })
        .catch((err) => {
          console.log("[ERR] deleteTreatments ", err);
          this.msgwindow.error("Error borrando tratamientos !");
        })
        .then(() => {
          this.updateQuotations();
        });
    },
    reorderTreatments(treatments, quotation_id) {
      axios
        .post(`/customer/${this.customer.id}/reorder_treatments`, {
          treatments: treatments,
          quotation_id: quotation_id,
        })
        .then((response) => {
          this.msgwindow.success("Tratamientos actualizados");
        })
        .catch((err) => {
          console.log("[ERR] reorderTreatments ", err);
          this.msgwindow.error("Error actualizando tratamientos !");
        })
        .then(() => {
          this.updateQuotations();
        });
    },

    reorderQuotations() {
      const quotations = this.quotations.map((x) => x.id);

      axios
        .post(`/customer/${this.customer.id}/reorder_quotations`, {
          quotations,
        })
        .then((response) => {
          this.msgwindow.success("Planes actualizados");
        })
        .catch((err) => {
          console.log("[ERR] reorderQuotations ", err);
          this.msgwindow.error("Error actualizando planes !");
        })
        .then(() => {
          this.updateQuotations();
        });
    },
    searchProducts(search, loading = null) {
      if (loading) {
        loading(true);
      }
      axios
        .get("/product", {
          params: {
            size: 100,
            search: search,
            search_product_ids: this.quotation_products,
            show_disabled: true,
          },
        })
        .then((response) => {
          if (loading) {
            loading(false);
          }
          this.searched_products = response.data.data;
        })
        .catch((error) => {
          console.log("[ERR] searchProducts:", error);
        })
        .then(() => {
          if (loading) {
            loading(false);
          }
        });
    },
  },
  mounted() {
    this.updateQuotations();
  },
};
</script>

<style lang="scss">
.customer-edit-quotations {
  &__topbar {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 3px var(--theme-grey-bg) solid;
  }
}
</style>
